export enum InvoicesActionPoint {
  CreateInvoice = 1,
  Overdue = 2,
  Unpaid = 3,
  Draft = 4,
  CreateInvoiceNow = 5,
  ShowMeHow = 6,
  Paid = 7,
}
